import React, { Fragment, useState } from 'react';
import { Redirect } from 'react-router-dom';
import EditableTitle from '../TabManage/EditableTitle';
import TabSelector from '../../Shared/Filters/TabSelector';
import { useDataEventsState, usePracticeDataUpdateDispatch } from 'store/hooks';
import { useManageDispatch } from 'store/hooks/manage';
import { Manage } from 'config/commonTypes';

type CombineHeaderProps = {
  currentPractice: Manage;
  setCurrentPractice: React.Dispatch<React.SetStateAction<Manage>>;
  setIsUpdating: React.Dispatch<React.SetStateAction<boolean>>;
  disableUpdate: boolean;
}

const CombineHeader =  ({
                  currentPractice, setCurrentPractice, setIsUpdating, disableUpdate
                }:CombineHeaderProps) => {

  const { dataEvent:practice = undefined, data:manageData, meta, mongoId } = useDataEventsState();
  const eventId = meta?._id;
  const league = meta?.league;
  const { noSave } = usePracticeDataUpdateDispatch();
  const { getPractice } = useManageDispatch();
  const [show, setShow] = useState(-1);
  const [redirect, setRedirect] = useState(false);
  
  if (redirect) {
    return <Redirect to="/" />;
  }

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    noSave(true);
    if (event.target.value !== ' ') {
      setCurrentPractice({ ...currentPractice, name: event.target.value });
    }
  };
  const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    noSave(true);
    if (event.target.value !== ' ') {
      setCurrentPractice({ ...currentPractice, description: event.target.value });
    }
  };

  const updateEvents = () =>{
    setIsUpdating(true);
    getPractice(eventId, league, false);
  };

  return (

    <Fragment>
      <TabSelector show={show === 1} open={() => setShow(1)} close={() => setShow(-1)} />
      <EditableTitle
        editable={false} text={currentPractice ? currentPractice.name : ''}
        handleChange={handleNameChange} title="Practice Name" style={{ marginLeft: '167px' }}
      />
      <EditableTitle
        editable={false} text={currentPractice ? currentPractice.description : ''}
        handleChange={handleDescriptionChange} title="Practice Description"
      />
      <div className="entities-btn">
       <button style={disableUpdate ? { opacity: 0.9, cursor: 'default', pointerEvents: 'none' } :{}}
        onClick={()=>updateEvents()} className="btn-lo"><i className="mdi mdi-refresh" /></button>
        </div>
    </Fragment>
  );
};
export default CombineHeader;
